import { ReactNode } from 'react';
import { Copy } from '@styled-icons/feather/Copy';

import * as S from './styles';

export type CopyCodeTypes = {
  code: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  icon?: ReactNode;
};

const CopyCode = ({
  code,
  icon,
  variant = 'primary',
  onClick,
}: CopyCodeTypes) => {
  return (
    <S.Wrapper variant={variant}>
      <S.IconContainer>
        {icon && icon}
        <S.Code>{code}</S.Code>
      </S.IconContainer>
      <S.Copy type="button" onClick={onClick}>
        <Copy size={22} />
      </S.Copy>
    </S.Wrapper>
  );
};

export default CopyCode;
